export const LegalStatusApi = Symbol.for('LegalStatusApi');
